import { render } from "./StoreSales.vue?vue&type=template&id=2a15a168&scoped=true"
import script from "./StoreSales.vue?vue&type=script&lang=js"
export * from "./StoreSales.vue?vue&type=script&lang=js"

import "./StoreSales.vue?vue&type=style&index=0&id=2a15a168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a15a168"]])

export default __exports__